import { memo } from 'react';
import { Handle, Position, NodeResizer } from '@xyflow/react';

const getShape = ({ data, selected }) => {
    return (
        <svg fill="#000000" viewBox="0 0 24 24" id="file-code-4" data-name="Line Color" xmlns="http://www.w3.org/2000/svg" class="icon line-color">
            <g id="SVGRepo_bgCarrier" stroke-width="0">
            </g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier"><polyline id="secondary" points="19 21 21 19 19 17"
                style={{ fill: "none", stroke: "#2ca9bc", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": 2 }}></polyline>
                <polyline id="secondary-2" data-name="secondary" points="15 17 13 19 15 21" style={{ fill: "none", stroke: "#2ca9bc", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": 2 }}></polyline>
                <path id="secondary-3" data-name="secondary" d="M7,13h6M7,9h6" style={{ fill: "none", stroke: "#2ca9bc", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": 2 }}></path>
                <path id="primary" d="M9,21H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3h9l4,4v6" style={{ "fill": "none", stroke: "#000000", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": 2}}></path>
                {!data.bfm_data?.name ? ( <text x="60%" y="75%" dominant-baseline="middle" font-size={5} text-anchor="middle">MACRO</text>) : (null)}
            </g>
        </svg>
    );
}

export {
    getShape
}